<script>
    // @check-js
    import Icon from "svelte-fa";
    import { faArrowAltCircleRight } from "@fortawesome/free-solid-svg-icons";
    import { trackNavigationClickTypes, trackNavigationClick } from "$utils/track.utils.js";
    import { MENU_TYPES } from "./menu.lib";
    /** @type {import('./types').SubMenuChild[]} */
    export let submenu;
    export let showListStyle = true;
    export let singleColumn = false;
</script>

<ul class:single-col={singleColumn}>
    {#each submenu as item}
        <li class:no-hover={item.type === MENU_TYPES.EMPTY_SPACE}>
            {#if item.type === MENU_TYPES.LINK}
                <div class="link-wrapper">
                    <a
                        data-sveltekit-preload-data="hover"
                        href={item.url}
                        title={item.name}
                        on:click={() => trackNavigationClick(trackNavigationClickTypes.MENU_CLICK, item.name)}
                    >
                        {#if showListStyle}
                            <Icon icon={faArrowAltCircleRight} />
                        {/if}
                        <span>{item.name}</span>
                    </a>
                </div>
            {:else if item.type === MENU_TYPES.EMPTY_SPACE}
                <span>&nbsp;</span>
            {:else if item.type === MENU_TYPES.COLOR_LINK}
                <div class="color-wrapper">
                    <a
                        data-sveltekit-preload-data="hover"
                        href={item.url}
                        on:click={() => trackNavigationClick(trackNavigationClickTypes.MENU_CLICK, item.name)}
                    >
                        <div class="color" style="background: {item.color}" />
                        <div>{item.name}</div>
                    </a>
                </div>
            {/if}
        </li>
    {/each}
</ul>

<style>
    a {
        color: white;
        text-decoration: none;
    }
    a:hover {
        color: white;
    }
    ul {
        list-style: none;
        column-count: auto;
        column-width: 11rem;
    }
    ul li:not(.no-hover):hover {
        background: rgba(50, 50, 50, 0.9);
        cursor: pointer;
    }
    li {
        flex: 0 0 20%;
        min-width: 160px;
        border-radius: 2px;
        white-space: nowrap;
        user-select: none;
        display: inline-block;
    }
    li a,
    li > span {
        padding: 10px 10px;
        display: block;
    }
    ul.single-col {
        column-count: 1;
    }
    ul.single-col li {
        display: list-item;
    }
    .color-wrapper a {
        display: flex;
        align-items: center;
    }
    .color {
        width: 40px;
        height: 40px;
        border-radius: 3px;
        border: 1px solid #aaa;
        margin-right: 8px;
    }
    .link-wrapper a {
        display: flex;
        align-items: center;
    }
    .link-wrapper span {
        margin: 0 0 0 8px;
        padding: 0;
    }
</style>
